import { formatCoord, type GridLike } from './grid.ts';
import type { Issue } from './issues.ts';

const GRID_CHAR = /^[A-Z#.]$/;

/**
 * Checks the grid's shape against `width`/`height` and its alphabet. Shared by the parser
 * (it is structural) and the validator (puzzles built in code skip the parser). Every
 * other check reads cells, so a puzzle failing this one is not worth checking further.
 */
export function checkGrid(puzzle: GridLike): Issue[] {
	const issues: Issue[] = [];
	const { width, height, grid } = puzzle;

	if (grid.length !== height) {
		issues.push({
			code: 'grid-size-mismatch',
			message: `The grid has ${grid.length} rows but height is ${height}.`,
			path: 'grid',
		});
	}

	grid.forEach((row, r) => {
		if (row.length !== width) {
			issues.push({
				code: 'grid-size-mismatch',
				message: `Grid row ${r} has ${row.length} cells but width is ${width}.`,
				path: `grid[${r}]`,
			});
		}
		[...row].forEach((char, c) => {
			if (GRID_CHAR.test(char)) return;
			const cell = { row: r, col: c };
			issues.push({
				code: 'invalid-grid-char',
				message: `Cell ${formatCoord(cell)} is ${JSON.stringify(char)}; use A–Z for a letter, "#" for a clue cell or "." for a blank.`,
				path: `grid[${r}]`,
				cell,
			});
		});
	});

	return issues;
}
